import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Container,
  Dropdown,
  Nav,
  Tab,
  OverlayTrigger,
  Tooltip,
  Button,
  Form,
  Modal,
  Carousel as CarouselN,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import ReactFsLightbox from "fslightbox-react";
import toast, { Toaster } from "react-hot-toast";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import axios from "axios";

import Card from "../../../components/Card";
import CustomToggle from "../../../components/dropdowns";
import ShareOffcanvas from "../../../components/share-offcanvas";
import useAuth from "../../../utils/useAuth";
import "./Profile.css";

import img1 from "../../../assets/images/page-img/profile-bg1.jpg";
import img5 from "../../../assets/images/icon/10.png";
import user1 from "../../../assets/images/user/1.jpg";
import user05 from "../../../assets/images/user/05.jpg";
import user02 from "../../../assets/images/user/02.jpg";
import user03 from "../../../assets/images/user/03.jpg";
import user06 from "../../../assets/images/user/06.jpg";
import user07 from "../../../assets/images/user/07.jpg";
import user08 from "../../../assets/images/user/08.jpg";
import user09 from "../../../assets/images/user/09.jpg";
import user10 from "../../../assets/images/user/10.jpg";
import icon1 from "../../../assets/images/icon/01.png";
import icon2 from "../../../assets/images/icon/02.png";
import icon3 from "../../../assets/images/icon/03.png";
import icon4 from "../../../assets/images/icon/04.png";
import icon5 from "../../../assets/images/icon/05.png";
import icon6 from "../../../assets/images/icon/06.png";
import icon7 from "../../../assets/images/icon/07.png";
import icon8 from "../../../assets/images/icon/08.png";
import icon9 from "../../../assets/images/icon/09.png";
import icon10 from "../../../assets/images/icon/10.png";
import icon11 from "../../../assets/images/icon/11.png";
import icon12 from "../../../assets/images/icon/12.png";
import icon13 from "../../../assets/images/icon/13.png";
import g1 from "../../../assets/images/page-img/g1.jpg";
import g2 from "../../../assets/images/page-img/g2.jpg";
import g3 from "../../../assets/images/page-img/g3.jpg";
import g4 from "../../../assets/images/page-img/g4.jpg";
import g5 from "../../../assets/images/page-img/g5.jpg";
import g6 from "../../../assets/images/page-img/g6.jpg";
import g7 from "../../../assets/images/page-img/g7.jpg";
import g8 from "../../../assets/images/page-img/g8.jpg";
import g9 from "../../../assets/images/page-img/g9.jpg";
import small07 from "../../../assets/images/small/07.png";
import small08 from "../../../assets/images/small/08.png";
import small09 from "../../../assets/images/small/09.png";
import small1 from "../../../assets/images/small/07.png";
import small2 from "../../../assets/images/small/08.png";
import small3 from "../../../assets/images/small/09.png";
import small4 from "../../../assets/images/small/10.png";
import small5 from "../../../assets/images/small/11.png";
import small6 from "../../../assets/images/small/12.png";
import small7 from "../../../assets/images/small/13.png";
import small8 from "../../../assets/images/small/14.png";
import user9 from "../../../assets/images/user/1.jpg";
import img59 from "../../../assets/images/page-img/59.jpg";
import img51 from "../../../assets/images/page-img/51.jpg";
import img52 from "../../../assets/images/page-img/52.jpg";
import img53 from "../../../assets/images/page-img/53.jpg";
import img54 from "../../../assets/images/page-img/54.jpg";
import img55 from "../../../assets/images/page-img/55.jpg";
import img56 from "../../../assets/images/page-img/56.jpg";
import img57 from "../../../assets/images/page-img/57.jpg";
import img58 from "../../../assets/images/page-img/58.jpg";
// import img59 from '../../../assets/images/page-img/59.jpg'
import img60 from "../../../assets/images/page-img/60.jpg";
import img61 from "../../../assets/images/page-img/61.jpg";
import img62 from "../../../assets/images/page-img/62.jpg";
import img64 from "../../../assets/images/page-img/64.jpg";
import img65 from "../../../assets/images/page-img/65.jpg";
import img63 from "../../../assets/images/page-img/63.jpg";
import img2 from "../../../assets/images/user/11.png";
import img3 from "../../../assets/images/icon/08.png";
import img4 from "../../../assets/images/icon/09.png";
// import img5 from '../../../assets/images/icon/10.png'
import img6 from "../../../assets/images/icon/11.png";
import img7 from "../../../assets/images/icon/12.png";
import img8 from "../../../assets/images/icon/13.png";
import img9 from "../../../assets/images/page-img/07.jpg";
import img10 from "../../../assets/images/page-img/06.jpg";
import p1 from "../../../assets/images/page-img/p1.jpg";
import p3 from "../../../assets/images/page-img/p3.jpg";
// import user1 from '../../../assets/images/user/1.jpg'
// import user05 from '../../../assets/images/user/05.jpg'
import user01 from "../../../assets/images/user/01.jpg";
// import user02 from '../../../assets/images/user/02.jpg'
// import user03 from '../../../assets/images/user/03.jpg'
// import user06 from '../../../assets/images/user/06.jpg'
// import user07 from '../../../assets/images/user/07.jpg'
// import user08 from '../../../assets/images/user/08.jpg'
// import user09 from '../../../assets/images/user/09.jpg'
// import user10 from '../../../assets/images/user/10.jpg'
import user13 from "../../../assets/images/user/13.jpg";
import user14 from "../../../assets/images/user/14.jpg";
import user15 from "../../../assets/images/user/15.jpg";
import user16 from "../../../assets/images/user/16.jpg";
import user17 from "../../../assets/images/user/17.jpg";
import user18 from "../../../assets/images/user/18.jpg";
import user19 from "../../../assets/images/user/19.jpg";
import loader from "../../../assets/images/page-img/page-load-loader.gif";
import { useNavigate } from "react-router-dom";
import { MdOutlineDone } from "react-icons/md";
import ProfileTab from "./profiletab";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../Context/UserContext";
import { getToken } from "../../../utils/auth";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../app/cropImage";
// Fslightbox plugin
const FsLightbox = ReactFsLightbox.default
  ? ReactFsLightbox.default
  : ReactFsLightbox;

const Profile1 = () => {
  useAuth();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { userData, updateUserProfile, fetchUserData } = useUser();
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [isProfileImage, setIsProfileImage] = useState(false);
  // const [userData, setUserData] = useState(null);
  const [userid, setUserid] = useState("");
  const [userUid, setUserUid] = useState("");
  const [loading, setLoading] = useState(true);


  const fetchUserData1 = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // setUserData(response?.data?.data);
      setUserid(response?.data?.data._id);
      setUserUid(response?.data?.data.UID);
      setLoading(false);
    } catch (error) {
      console.error("Failed Fetching Details", error);
      setLoading(false);
    }
  };
  const [imageSrc, setImageSrc] = useState(null);
  // const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  // const [showCropModal, setShowCropModal] = useState(false);
  // const [showProfileCrop, setShowProfileCrop] = useState(false);
  // const [showCoverCrop, setShowCoverCrop] = useState(false);



//delete thiss code of anything happens
const [profileImageSrc, setProfileImageSrc] = useState(null);
const [profileCrop, setProfileCrop] = useState({ x: 0, y: 0 });
const [profileZoom, setProfileZoom] = useState(1);
const [profileCroppedAreaPixels, setProfileCroppedAreaPixels] = useState(null);
const [showProfileCropModal, setShowProfileCropModal] = useState(false);




  
  const [coverImageSrc, setCoverImageSrc] = useState(null);
const [coverCrop, setCoverCrop] = useState({ x: 0, y: 0 });
const [coverZoom, setCoverZoom] = useState(1);
const [coverCroppedAreaPixels, setCoverCroppedAreaPixels] = useState(null);
const [showCoverCropModal, setShowCoverCropModal] = useState(false);

  const handleImageChange = async (event) => {
    const file = event.target.files[0];

    // Check if file exists
    if (!file) {
      return;
    }

    // Validate file type
    const validImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    if (!validImageTypes.includes(file.type)) {
      toast.error("Please upload a valid image file (JPEG, PNG, GIF, or WEBP)");
      return;
    }

    // Validate file size (1MB = 1024 * 1024 bytes)
    const maxSize = 1024 * 1024; // 1MB
    if (file.size > maxSize) {
      toast.error("Image size must be less than 1MB");
      return;
    }

    // Read the file and show cropping modal
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      setProfileImageSrc(reader.result);
      setShowProfileCropModal(true); 
    });
    reader.readAsDataURL(file);
  }; 
  const onProfileCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setProfileCroppedAreaPixels(croppedAreaPixels);
  }, []);


const handleProfileCropSave = useCallback(async () => {
    try {
      setLoading(true);
      const croppedImage = await getCroppedImg(profileImageSrc, profileCroppedAreaPixels, 400,
  400,
  true);

      const file = new File([croppedImage], "profile.jpg", {
        type: "image/jpeg",
      });

      const formData = new FormData();
      formData.append("profileImage", file);

      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/user/edit-profile`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success(response.data.message || "Profile Updated successfully!");
      updateUserProfile(response.data.data);
      fetchUserData();
      fetchUserData1();

      setShowProfileCropModal(false);
      setProfileImageSrc(null);
      setProfileCrop({ x: 0, y: 0 });
      setProfileZoom(1);
    } catch (error) {
      console.error("Failed to update profile image", error);
      toast.error(
        error.response?.data?.message || "Failed to update profile image"
      );
    } finally {
      setLoading(false);
    }
  }, [profileImageSrc, profileCroppedAreaPixels]);


  useEffect(() => {
    fetchUserData();
    fetchUserData1();
  }, [userid]);
  //    const {userid} = useParams();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [post, setPost] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const handleAllPost = async (updateData = false) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/post/all?page=${page}&limit=5`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("Post Fetched Successfully", response.data.data.allPosts);
      // setPost(response.data.data.allPosts);
      // setHasMore(response.data.data.allPosts.length > 0);
      if (updateData) {
        setPost(response.data.data.allPosts);
      } else {
        setPost((prevPost) => [...prevPost, ...response.data.data.allPosts]);
      }
      setHasMore(response.data.data.allPosts.length > 0);
    } catch (error) {
      console.log("Failed Fetching Posts", error);
    }
  };

  useEffect(() => {
    handleAllPost(true);
  }, [page, userid]);

  const [expandedRows, setExpandedRows] = useState({});

  const toggleExpand = (index) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [index]: !prevExpandedRows[index],
    }));
  };
  const renderDescription = (data, index) => {
    const description = data?.description;
    const threshold = 180;

    if (description && description.length > threshold) {
      if (expandedRows[index]) {
        return (
          <div>
            <div dangerouslySetInnerHTML={{ __html: description }} />
            <button
              onClick={() => toggleExpand(index)}
              style={{
                color: "#FF5500",
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "block",
              }}
            >
              Show Less...
            </button>
          </div>
        );
      } else {
        return (
          <div>
            <div
              style={{ display: "inline" }}
              dangerouslySetInnerHTML={{
                __html: `${description.slice(0, threshold)}...`,
              }}
            />
            <button
              onClick={() => toggleExpand(index)}
              style={{
                color: "#FF5500",
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "inline",
              }}
            >
              Show More...
            </button>
          </div>
        );
      }
    } else {
      return <div dangerouslySetInnerHTML={{ __html: description }} />;
    }
  };

  const [imageController, setImageController] = useState({
    toggler: false,
    slide: 1,
  });
  const [userDetail, setUserDetail] = useState("");
  const handleUserDetail = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/scan-profile/${userid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("User Detail fetched successfully ", response.data.data.noOfConnection);
      setUserDetail(response.data.data);
    } catch (error) {
      console.log("Failed Fetching User Detail", error);
    }
  };

  useEffect(() => {
    handleUserDetail();
  }, [userid]);

  const handleSendRequest = async () => {
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/connection/sent-request`,
        {
          requestTo: userid,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response.data.message);
      // console.log("Request Send successfully");
    } catch (error) {
      toast.error(error.response.data.message);
      console.log("Failed Sending Friend Request", error);
    }
  };

  const handleSavePost = async (postID) => {
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/post/save/${postID}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "multipart/form-data"
          },
        }
      );
      // console.log("Post Saved", response.data);
      toast.success(response.data.message);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed Saving Post");
      console.log("Failed Saving Posts", error);
    }
  };

  function imageOnSlide(number) {
    setImageController({
      toggler: !imageController.toggler,
      slide: number,
    });
  }
  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState("");
  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
  };

  const closeQrPopup = () => {
    setQrPopupOpen(false);
  };

  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [reportDescription, setReportDescription] = useState("");
  const [reportId, setReportId] = useState("");
  const handleReportClick = (reqid) => {
    setReportId(reqid);
    setReportModalOpen(true);
  };

  const closeReportModal = () => {
    setReportModalOpen(false);
  };
  const handleReport = async () => {
    if (!reportDescription) {
      toast.info("Report issue is required");
      return;
    }
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/report`,
        {
          reportFor: "post",
          issueDescription: reportDescription,
          userId: "",
          postId: reportId,
          eventId: "",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      closeReportModal();
      setReportId("");
      setReportDescription("");
      // console.log("Post Reported", response.data);
      toast.success(response.data.message);
    } catch (error) {
      setReportId("");
      setReportDescription("");
      toast.error(error?.response?.data?.message || "Failed Reporting Post");
      console.log("Failed Reporting Posts", error);
    }
  };

  const [connection, setConnection] = useState([]);

  const handleConnections = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/connection/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("Connections Fetched Successfully");
      setConnection(response.data.data);
    } catch (error) {
      console.log("Failed Fetching Posts", error);
    }
  };
  useEffect(() => {
    handleConnections();
  }, []);


  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);

  const handleFileInputChange = (event) => {
    setSelectedFile([...event.target.files]);
    toast.success("File selected!");
  };
  const [categorypost, setCategorypost] = useState("public");

  const handleCategoryChange = (e) => {
    setCategorypost(e.target.value);
  };

  const [photos, setPhotos] = useState([]);
  const handlePost = async () => {
    if (!description) {
      toast.info("Description is required");
      return;
    }
    try {
      const token = getToken();
      const formData = new FormData();
      for (let i = 0; i < selectedFile.length; i++) {
        formData.append("files", selectedFile[i]);
      }

      const uploadResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("oath", uploadResponse.data.data);

      setPhotos(uploadResponse.data.data);
      postPhoto(uploadResponse.data.data);

      //   setShow(false);
    } catch (error) {
      console.log("Failed to create post:", error);
      toast.error(
        error?.uploadResponse?.data?.message || "Failed to Upload Image/Video"
      );
    }
  };

  const postPhoto = async (photoss) => {
    if (!description) {
      toast.info("Description is required");
      return;
    }
    try {
      const token = getToken();
      const postData = {
        description: description,
        photos: photoss,
        postType: categorypost,
      };

      const postResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/post`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleAllPost(true);
      // console.log("Post Successfully", postResponse.data);
      toast.success("Post created successfully");
      setDescription("");
      setSelectedFile([]);
      //   setShow(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log("Failed Posting ", error);
    } finally {
      setShow(false);
    }
  };
  const [userDetailSocial, setUserDetailSocial] = useState("");
  const handleUserDetailSocial = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/social-profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log(
      //   "User Detail fetched successfully social",
      //   response.data.data.userData
      // );
      let detail = response.data.data.userData;
      setEditForm({
        userBio: detail?.userProfileData?.userBio,
        city: detail?.userProfileData?.address?.city,
        country: detail?.userProfileData?.address?.country,
        birthday: detail?.userProfileData?.birthday,
      });
      setUserDetailSocial(detail);
    } catch (error) {
      console.log("Failed Fetching User Detail", error);
    }
  };

  useEffect(() => {
    handleUserDetailSocial();
  }, []);

  const [profileInfo, setProfileInfo] = useState(true);
  const [edit, setEdit] = useState(false);
  const [editForm, setEditForm] = useState({
    userBio: "",
    city: "",
    country: "",
    birthday: "",
  });
  const openEdit = () => {
    setProfileInfo(false);
    setEdit(true);
  };

  const handleSave = async () => {
    // console.log(editForm);
    try {
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/user/social-profile`,
        editForm,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleUserDetailSocial();
      setProfileInfo(true);
      setEdit(false);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };

  const handleEditFormChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };
  const [coverImage, setCoverImage] = useState(null);
  const fileInputRef = useRef(null);

  const handleClick = () => {
    // console.log("fileInputRef", fileInputRef);
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

    const handleCropSave = async () => {
  const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);

  // Convert to File
  const file = new File([croppedImage], "cover.jpg", {
    type: "image/jpeg",
  });

  setCoverImage(file); // now trigger upload
  setShowCoverCropModal(false);
};


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if(!file)return;

    const reader =  new FileReader();
    reader.onload = ()=>{
      setCoverImageSrc(reader.result);
      setShowCoverCropModal(true);
    };
    reader.readAsDataURL(file);
  };

  const onCoverCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCoverCroppedAreaPixels(croppedAreaPixels);
  }, []);


  const handleCoverCropSave = async () => {
    try {
      setLoading(true);
      const croppedImage = await getCroppedImg(coverImageSrc, coverCroppedAreaPixels,1200,
  675,
  false);
      const file = new File([croppedImage], "cover.jpg", {
        type: "image/jpeg",
      });

      const token = getToken();
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const uploadProfile = await axios.put(
        `${process.env.REACT_APP_URL}/api/user/social-profile`,
        {
          backgroundImageUrl: response.data.data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Cover image updated successfully!");
      handleUserDetailSocial();

      setShowCoverCropModal(false);
      setCoverImageSrc(null);
      setCoverCrop({ x: 0, y: 0 });
      setCoverZoom(1);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };


  // console.log("image",coverImage)
  const handleEditCover = async () => {
    // Check if coverImage exists
    if (!coverImage) {
      toast.error("Please select an image first");
      return;
    }

    // Validate file type
    const validImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    if (!validImageTypes.includes(coverImage.type)) {
      toast.error("Please upload a valid image file (JPEG, PNG, GIF, or WEBP)");
      return;
    }

    // Validate file size (1MB = 1024 * 1024 bytes)
    const maxSize = 1024 * 1024; // 1MB
    if (coverImage.size > maxSize) {
      toast.error("Cover image size must be less than 1MB");
      return;
    }

    try {
      setLoading(true); // Assuming you have a loading state
      const token = getToken();

      // Upload the file
      const formData = new FormData();
      formData.append("file", coverImage);

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Important for file uploads
          },
        }
      );

      // Update user profile with the new cover image URL
      const uploadProfile = await axios.put(
        `${process.env.REACT_APP_URL}/api/user/social-profile`,
        {
          backgroundImageUrl: response.data.data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Cover image updated successfully!");
      handleUserDetailSocial();

      // Reset states if needed
      setCoverImage(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the file input
      }
    } catch (error) {
      console.error("Failed to update cover image", error);

      let errorMessage = "Failed to update cover image";
      if (error.response) {
        // Server responded with error status
        errorMessage = error.response.data.message || errorMessage;
      } else if (error.request) {
        // Request was made but no response received
        errorMessage = "Network error - please check your connection";
      }

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };








  
  // useEffect(() => {
  //   if (coverImage) {
  //     handleEditCover();
  //   }
  // }, [coverImage]);

  if (loading) {
    return (
      <div className="loader-container">
        <img src={loader} alt="Loading..." />
      </div>
    );
  }

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <FsLightbox
        toggler={imageController.toggler}
        sources={[
          g1,
          g2,
          g3,
          g4,
          g5,
          g6,
          g7,
          g8,
          g9,
          img51,
          img52,
          img53,
          img54,
          img55,
          img56,
          img57,
          img58,
          img59,
          img60,
          img61,
          img62,
          img63,
          img64,
          img65,
          img51,
          img52,
          img53,
          img54,
          img55,
          img56,
          img57,
          img58,
          img51,
          img52,
          img53,
          img54,
          img55,
          img56,
          img57,
          img58,
          img59,
          img60,
        ]}
        slide={imageController.slide}
      />
      <Container className="p-2">
        {/* <Row> */}
          <Col sm={12}>
            <Card>
              <Card.Body className=" profile-page p-0">
                <div className="profile-header">
                  <div className="position-relative">
                    <img
                      loading="lazy"
                      src={
                        userDetailSocial?.userProfileData?.backgroundImageUrl
                          ? userDetailSocial?.userProfileData
                              ?.backgroundImageUrl
                          : img1
                      }
                      alt="profile-bg"
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                      }}
                      className="rounded img-fluid"
                      onClick={() => {
                        setEnlargedImage(
                          userDetailSocial?.userProfileData?.backgroundImageUrl
                            ? userDetailSocial?.userProfileData
                                ?.backgroundImageUrl
                            : img1
                        );
                        setIsProfileImage(false);
                      }}
                    />
                    <ul
                      className="header-nav list-inline d-flex flex-wrap p-0 m-0"
                      style={{
                        width: "100%",
                        zIndex: "999",
                        justifyContent: "space-between",
                        paddingLeft: "15px",
                        alignItems: "end",
                      }}
                    >
                      <li className="qr-code-li largescreen">
                        <img
                          src={userDetailSocial?.qrCodeURL}
                          alt="QR"
                          onClick={() =>
                            handleQrClick(userDetailSocial?.qrCodeURL)
                          }
                          style={{
                            width: "130px",
                            height: "130px",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                          }}
                        />
                        <div
                          style={{ textAlign: "center", marginTop: "-10px" }}
                        >
                          {userDetailSocial?.UID}
                        </div>
                      </li>
                      <li
                        style={{
                          // marginLeft: "15px",
                          // position: "absolute",
                          // right: "10px",
                          // bottom: "0px",
                          // zIndex: "999",
                          // border:"2px solid red"
                        }}
                      >
                        <a
                          href="#"
                          onClick={handleClick}
                          className="material-symbols-outlined"
                          style={{
                            position: "absolute",
                          top: "8px",
                          right: "8px",
                          backgroundColor: "#fff",
                          borderRadius: "50%",
                          padding: "6px",
                          cursor: "pointer",
                          fontSize: "20px",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                          }}
                        >
                          edit
                        </a>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                          accept="image/*" // Restrict to image files
                        />
                      </li>
                    </ul>
                  </div>
                  
                  <div className="user-detail text-center mb-3">
                    {/* <div className="profile-img">
                      <img
                        loading="lazy"
                        src={
                          !userData?.profileImageLink
                            ? "/profile.png"
                            : userData?.profileImageLink
                        }
                        alt="profile-img"
                        className="avatar-130 img-fluid"
                        style={{ width: "120px", height: "120px" }}
                      />{" "}
                    </div> */}
                    <div
                      className="profile-img"
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      <img
                        loading="lazy"
                        src={userData?.profileImageLink || "/profile.png"}
                        alt="profile-img"
                        className="avatar-130 img-fluid"
                        style={{
                          width: "120px",
                          height: "120px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          cursor: "pointer", // Add pointer cursor to indicate clickable
                        }}
                        onClick={() =>
                          setEnlargedImage(
                            userData?.profileImageLink || "/profile.png"
                          )
                        }
                      />

                      <a
                        // href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation(); // Prevent triggering the image enlargement
                          document.getElementById("fileInput").click();
                        }}
                        className="material-symbols-outlined"
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          backgroundColor: "#fff",
                          borderRadius: "50%",
                          padding: "6px",
                          cursor: "pointer",
                          fontSize: "20px",
                          border:"2px solid red",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                        }}
                      >
                        edit
                      </a>
                      <input
                        type="file"
                        id="fileInput"
                        style={{ display: "none" }}
                        onChange={handleImageChange}
                        accept="image/*,.jpg,.jpeg,.png,.gif,.webp"
                      />
                    </div>

                    {/* Modal for enlarged image */}
                    {enlargedImage && (
                      <div
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: "rgba(0, 0, 0, 0.95)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 10000,
                          cursor: "pointer",
                        }}
                        onClick={() => setEnlargedImage(null)}
                      >
                        {/* Main image container with max dimensions */}
                        <div
                          style={{
                            maxWidth: "90vw",
                            maxHeight: "90vh",
                            // position: "relative",
                            // width: "80vw",
                            // height: "80vh",
                            // maxWidth: "1200px",
                            // maxHeight: "800px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {/* Image with constrained dimensions and centered */}
                          <img
                            src={enlargedImage}
                            alt="Enlarged view"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              borderRadius: isProfileImage ? "50%" : "0",
                              // borderRadius: isProfileImage ? "50%" : "4px",
                              objectFit: "contain",
                              pointerEvents: "none", // Disable image interactions
                              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
                            }}
                          />

                          {/* Close button - improved styling */}
                          <button
                            style={{
                              position: "absolute",
                              top: "20px",
                              right: "20px",
                              background: "rgba(255, 255, 255, 0.2)",
                              color: "white",
                              border: "none",
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                              fontSize: "24px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                              zIndex: 1001,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setEnlargedImage(null);
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.background =
                                "rgba(255, 255, 255, 0.3)")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.background =
                                "rgba(255, 255, 255, 0.2)")
                            }
                            aria-label="Close image viewer"
                          >
                            &times;
                          </button>
                        </div>
                      </div>
                    )}

                    <div className="profile-detail" style={{fontWeight:"600"}}>
                      <div style={{ fontSize: "18px" }}>
                        {userData?.firstName} {userData?.lastName}{" "}
                        <span
                          style={{
                            textTransform: "capitalize",
                            fontSize: "12px",
                          }}
                        >
                          ({userData?.clientUseFor})
                        </span>
                        <div style={{ fontSize: "17px" }}>
                          {userData?.clientUseFor === "individual" ? (
                            <div className="invisible">Nothing</div>
                          ) : (
                            userData?.nameOfBusiness || "Business name"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="profile-info p-3 d-flex align-items-center justify-content-between position-relative">
                    <div style={{ marginTop:"-60px"}} className="d-flex d-lg-none"/>
                    <div className="social-links">
                      <ul className="social-data-block d-none d-lg-flex align-items-center justify-content-between list-inline p-0 m-0">
                        <li className="text-center pe-3">
                          <h6>{t("posts")}</h6>
                          <p className="mb-0">
                            {userDetailSocial?.noOfPosts
                              ? userDetailSocial?.noOfPosts
                              : "0"}
                          </p>
                        </li>

                        <li className="text-center pe-3">
                          <h6>{t("connections")}</h6>
                          <p className="mb-0">
                            {userDetailSocial?.noOfConnection
                              ? userDetailSocial?.noOfConnection
                              : "0"}
                          </p>
                        </li>
                      </ul>
                       <ul className="social-data-block d-flex d-lg-none align-items-center justify-content-around list-inline p-0 m-0 mb-2">
      <li className="text-center">
        <h6 className="mb-1">{t("posts")}</h6>
        <p className="mb-0 fw-bold">
          {userDetailSocial?.noOfPosts ? userDetailSocial?.noOfPosts : "0"}
        </p>
      </li>
      <div style={{ width: '1px', height: '40px', backgroundColor: '#dee2e6' }}></div>
      <li className="text-center">
        <h6 className="mb-1">{t("connections")}</h6>
        <p className="mb-0 fw-bold">
          {userDetailSocial?.noOfConnection ? userDetailSocial?.noOfConnection : "0"}
        </p>
      </li>
    </ul>
                    </div>
                    <div className="social-info">
                      <ul
                        className="social-data-block d-flex align-items-center justify-content-center list-inline p-0 m-0"
                        style={{ justifyContent: "center" }}
                      >
                        <li className="text-center ">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                          </div>
                        </li>
                        <li className="text-center pe-3">
                          <h6 className="mb-0" style={{ display: "flex" }}>
                            {" "}
                            {userData?.mobile && (<>
                            <span className="material-symbols-outlined md-18">
                              call
                            </span>
                            <p className="mb-0 ms-2">{userData?.mobile}</p></>)}
                          </h6>
                          <h6 style={{ display: "flex" }}>
                            {" "}
                            <span className="material-symbols-outlined md-18">
                              email
                            </span>
                            <p className="mb-0 ms-2">{userData?.email}</p>
                          </h6>
                        </li>

        
                      </ul>
                      <div
                        className="qr-code-li1 largescreen1"
                      >
                        <img
                          src={userDetailSocial?.qrCodeURL}
                          alt="QR"
                          onClick={() =>
                            handleQrClick(userDetailSocial?.qrCodeURL)
                          }
                          style={{
                            width: "130px",
                            height: "130px",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                            display: "flex",
                            marginInline: "auto",
                          }}
                        />
                        <div
                          style={{ textAlign: "center", marginTop: "-10px" }}
                        >
                          {userDetailSocial?.UID}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="profile-info p-3 position-relative">
  <div className="social-links mb-3">
    <ul className="social-data-block d-flex align-items-center justify-content-around list-inline p-0 m-0">
      <li className="text-center">
        <h6 className="mb-1">{t("posts")}</h6>
        <p className="mb-0 fw-bold">
          {userDetailSocial?.noOfPosts ? userDetailSocial?.noOfPosts : "0"}
        </p>
      </li>
      <div style={{ width: '1px', height: '40px', backgroundColor: '#dee2e6' }}></div>
      <li className="text-center">
        <h6 className="mb-1">{t("connections")}</h6>
        <p className="mb-0 fw-bold">
          {userDetailSocial?.noOfConnection ? userDetailSocial?.noOfConnection : "0"}
        </p>
      </li>
    </ul>
  </div>
  <div className="social-info">
    <div className="contact-info-wrapper mb-3">
      {userData?.mobile && (
        <div className="d-flex align-items-center mb-2 p-2">
          <div className="icon-wrapper me-2" style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: '#e3f2fd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}>
            <span className="material-symbols-outlined md-18" style={{ color: '#1976d2' }}>
              call
            </span>
          </div>
          <p className="mb-0" style={{ wordBreak: 'break-word', flex: 1 }}>{userData?.mobile}</p>
        </div>
      )}
      
      <div className="d-flex align-items-center p-2">
        <div className="icon-wrapper me-2" style={{
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          backgroundColor: '#e8f5e9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}>
          <span className="material-symbols-outlined md-18" style={{ color: '#388e3c' }}>
            email
          </span>
        </div>
        <p className="mb-0" style={{ wordBreak: 'break-word', flex: 1 }}>{userData?.email}</p>
      </div>
    </div>

    <div className="qr-code-section " style={{
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)',
      padding: '1rem',
      borderRadius: '8px'
    }}>
      <div style={{ maxWidth: '200px', margin: '0 auto' }}>
        <div 
          className="qr-code-wrapper" 
          onClick={() => handleQrClick(userDetailSocial?.qrCodeURL)}
          style={{
            cursor: 'pointer',
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '0.75rem',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'box-shadow 0.3s ease'
          }}
          onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)'}
          onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)'}
        >
          <img
            src={userDetailSocial?.qrCodeURL}
            alt="QR"
            style={{
              width: '100%',
              height: 'auto',
              borderRadius: '4px',
              marginBottom: '0.5rem',
              display: 'block'
            }}
          />
          <div style={{
            textAlign: 'center',
            fontSize: '0.875rem',
            fontWeight: '500',
            color: '#495057',
            backgroundColor: '#f8f9fa',
            padding: '0.5rem',
            borderRadius: '4px'
          }}>
            {userDetailSocial?.UID}
          </div>
        </div>
        <p className="text-center mb-0 mt-2" style={{ fontSize: '0.75rem', color: '#6c757d' }}>
          Tap to enlarge
        </p>
      </div>
    </div>
  </div>
  <style jsx>{`
    @media (max-width: 576px) {
      .profile-info {
        padding: 0.75rem !important;
      }
      
      .social-data-block li h6 {
        font-size: 0.875rem;
      }
      
      .contact-info-wrapper {
        font-size: 0.875rem;
      }
      
      .qr-code-section {
        margin-top: 1rem;
      }
    }
    
    @media (min-width: 768px) {
      .qr-code-section {
        max-width: 250px;
        margin-left: auto;
        margin-right: auto;
      }
    }
  `}</style>
</div> */}
                </div>
              </Card.Body>
            </Card>
          </Col>
          <ProfileTab userUid={userUid} />
        {/* </Row> */}
        <Modal
          size="sm"
          style={{ zIndex: "99999" }}
          className="fade"
          id="qr-modal"
          onHide={closeQrPopup}
          show={qrPopupOpen}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("qr_code")}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <img
              src={qrImageUrl}
              alt="QR Code"
              style={{ width: "200px", height: "auto" }}
            />
            <div
              style={{
                textAlign: "center",
                fontSize: "18px",
                marginTop: "-10px",
              }}
            >
              {userDetailSocial?.UID}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <a
              href={qrImageUrl}
              download="qr-code.png"
              className="btn btn-primary"
            >
              {t("download")}
            </a>
            <button className="btn btn-secondary" onClick={closeQrPopup}>
              {t("close")}
            </button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showProfileCropModal}
          onHide={() => setShowProfileCropModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("cropYourProfilePicture")}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ height: "400px", position: "relative" }}>
            {profileImageSrc && (
              <Cropper
                image={profileImageSrc}
                crop={profileCrop}
                zoom={profileZoom}
                aspect={1} // Square aspect ratio
                onCropChange={setProfileCrop}
                onCropComplete={onProfileCropComplete}
                onZoomChange={setProfileZoom}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-between w-100">
              <div>
                <label className="me-2">{t("zoom")}:</label>
                <input
                  type="range"
                  min="1"
                  max="3"
                  step="0.1"
                  value={profileZoom}
                  onChange={(e) => setProfileZoom(parseFloat(e.target.value))}
                  className="form-range"
                  style={{ width: "150px" }}
                />
              </div>
              <div>
                <Button
                  variant="secondary"
                  onClick={() => setShowProfileCropModal(false)}
                  className="me-2"
                >
                  {t("cancel")}
                </Button>
                <Button variant="primary" onClick={handleProfileCropSave}>
                  {t("save")}
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </Container>
    <Modal show={showCoverCropModal} onHide={() => setShowCoverCropModal(false)} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{t("cropCoverImage") || "Crop Cover Image"}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ height: 400, position: "relative" }}>
        {coverImageSrc && (
          <Cropper
            image={coverImageSrc}
                crop={coverCrop}
                zoom={coverZoom}
                aspect={16/9}
            onCropChange={setCoverCrop}
            onCropComplete={onCoverCropComplete}
            onZoomChange={setCoverZoom}
          />
        )}
      </Modal.Body>

      <Modal.Footer>
    <div className="d-flex justify-content-between w-100">
      <div>
        <label className="me-2">{t("zoom")}:</label>
        <input
          type="range"
          min="1"
          max="3"
          step="0.1"
          value={coverZoom}
          onChange={(e) => setCoverZoom(parseFloat(e.target.value))}
          className="form-range"
          style={{ width: "150px" }}
        />
      </div>
      <div>
        <Button variant="secondary" onClick={() => setShowCoverCropModal(false)} className="me-2">
          {t("cancel")}
        </Button>
        <Button variant="primary" onClick={handleCoverCropSave}>
          {t("save")}
        </Button>
      </div>
    </div>
  </Modal.Footer>
    </Modal>
  </>
  );
};

export default Profile1;
